export default __webpack_public_path__ + "static/media/Pro-8a.76c32c0d.png";